import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "absolute z-20 w-full flex items-center px-16 xl:px-28 xl:h-[90px]" }
const _hoisted_2 = { class: "container mx-auto" }
const _hoisted_3 = { class: "flex flex-col lg:flex-row justify-between items-center gap-y-6 py-8" }
const _hoisted_4 = { class: "flex flex-col lg:flex-row justify-between items-center gap-y-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "lg:ms-8 my-auto text-lg xl:text-4xl uppercase font-bold" }, "Ihor Chernukha", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LogoIcon = _resolveComponent("LogoIcon")!
  const _component_Socials = _resolveComponent("Socials")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_LogoIcon, {
            height: "48px",
            width: "48px",
            class: "text-accent"
          }),
          _hoisted_5
        ]),
        _createVNode(_component_Socials)
      ])
    ])
  ]))
}